var _path;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgArrowDownTwo = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 9,
    viewBox: "0 0 18 9",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99953 8.80014C8.29953 8.80014 7.59953 8.53014 7.06953 8.00014L0.549531 1.48014C0.259531 1.19014 0.259531 0.710137 0.549531 0.420137C0.839531 0.130137 1.31953 0.130137 1.60953 0.420137L8.12953 6.94014C8.60953 7.42014 9.38953 7.42014 9.86953 6.94014L16.3895 0.420137C16.6795 0.130137 17.1595 0.130137 17.4495 0.420137C17.7395 0.710137 17.7395 1.19014 17.4495 1.48014L10.9295 8.00014C10.3995 8.53014 9.69953 8.80014 8.99953 8.80014Z",
    fill: "#455CC7"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrowDownTwo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ArrowDownTwo.5348caf3.svg";
export { ForwardRef as ReactComponent };